import type { ReactNode } from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

export interface FilterSelectItem {
  value: string;
  label: string;
}

interface FilterSelectProps {
  ariaLabel: string;
  className?: string;
  icon?: ReactNode;
  items: readonly FilterSelectItem[];
  showAppliedState?: boolean;
  value: string;
  onValueChange: (value: string) => void;
}

/** Compact selector used in data-table toolbars. */
export function FilterSelect({
  ariaLabel,
  className,
  icon,
  items,
  showAppliedState = true,
  value,
  onValueChange,
}: FilterSelectProps): React.ReactElement {
  const isApplied = value !== items[0]?.value;

  return (
    <Select items={items} value={value} onValueChange={(next) => onValueChange(next ?? value)}>
      <SelectTrigger
        size="sm"
        aria-label={ariaLabel}
        data-filter-applied={(showAppliedState && isApplied) || undefined}
        className={cn(
          "min-w-[100px] gap-[7px] px-2.5",
          showAppliedState && isApplied && "border-transparent bg-control-highlight",
          className,
        )}
      >
        {icon}
        <SelectValue />
      </SelectTrigger>
      <SelectContent align="end">
        <SelectGroup>
          {items.map((item) => (
            <SelectItem key={item.value} value={item.value}>
              {item.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
